module.exports = __webpack_public_path__ + "static/media/dn-logo.e861a8c2.png";